const resource = '/admin/v1/landings';

export default $axios => ({
  store(payload) {
    return $axios.post(resource, payload, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  update(id, payload) {
    return $axios.post(`${resource}/update/${id}`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  updateStatus(id, payload) {
    return $axios.post(`${resource}/update-status/${id}`, payload)
  },
  search(payload) {
    return $axios.post(`${resource}/search`, payload)
  },
  delete(id) {
    return $axios.delete(`${resource}/${id}`)
  },
  show(id) {
    return $axios.get(`${resource}/${id}`)
  },
  getMediaPostBySlug(slug) {
    return fetch(`https://legal-script.com/media/wp-json/wp/v2/posts?slug=${slug}&_embed`)
      .then(response => response.json())
      .then(data => {
        return data;
      })
      .catch(error => {
        console.error(error);
        return [];
      });
  }
});
